import React, { useEffect, useState } from 'react';
import { Inline, Stack } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import Spinner from '@atlaskit/spinner';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { CreateFlowDialog } from '../../list/creation-flow-dialog/index.tsx';
import { fetchApplinkManifestForUrl, fetchThisManifest } from '../../../rest/index.tsx';
import type { ApplicationLinkManifest } from '../../../common/entities.tsx';

type CreateLinkComponentProps = {
	onClose: () => void;
	targetUrl: string;
};

const styles = cssMap({
	modalPadding: {
		paddingTop: token('space.200'),
		paddingRight: token('space.100'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.100'),
		minHeight: '300px',
	},
});

const CreateOAuth2Modal = (props: CreateLinkComponentProps) => {
	const [localManifest, setLocalManifest] = useState<ApplicationLinkManifest | null>(null);
	const [remoteManifest, setRemoteManifest] = useState<ApplicationLinkManifest | null>(null);

	useEffect(() => {
		fetchThisManifest()
			.then((manifest) => {
				setLocalManifest(manifest);
			})
			.catch((err) => {
				const maybeError = err instanceof Error ? err : undefined;
				log.unsafeErrorWithCustomerData(
					'applinks.administration.hybrid.create-oauth2-modal.fetchOurManifest',
					'Failed to retrieve our own manifest (as part of portalled modal load) - this is really bad!',
					maybeError,
				);
			});
	}, []);

	useEffect(() => {
		fetchApplinkManifestForUrl(props.targetUrl)
			.then((manifest) => {
				setRemoteManifest(manifest);
			})
			.catch((err) => {
				const maybeError = err instanceof Error ? err : undefined;
				log.unsafeErrorWithCustomerData(
					'applinks.administration.hybrid.create-oauth2-modal.fetchTheirManifest',
					`Failed to retrieve the remote manifest (as part of portalled modal load). The Legacy FE should have validated the URL ${props.targetUrl} before passing it to us - has anything changed?`,
					maybeError,
				);
			});
	}, [props.targetUrl]);

	return (
		<Stack xcss={styles.modalPadding}>
			{localManifest && remoteManifest ? (
				<CreateFlowDialog
					isOpen
					onExit={props.onClose}
					startingStage={{
						kind: 'review',
						variant: 'OAUTH2.0',
						localManifest,
						remoteManifest,
					}}
				/>
			) : (
				<Inline alignInline="center" alignBlock="center">
					<Spinner />
				</Inline>
			)}
		</Stack>
	);
};

export default CreateOAuth2Modal;
